const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  "auth-server-url": process.env.REACT_APP_KEYCLOAK_URL,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  resource: process.env.REACT_APP_KEYCLOAK_CLIENT,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT,
  "public-client": true,
  "confidential-port": 0,
};

export default keycloakConfig;
